<template>
  <el-radio-group
    v-if="isDesktop"
    v-model="value"
    class="desktop"
    :disabled="disabled"
    @update:modelValue="update"
  >
    <el-tooltip
      v-for="ronTypeLabel in RonTypeLabels"
      :key="ronTypeLabel.type_id"
      :content="ronTypeLabel.tooltip"
      placement="top"
      :show-after="300"
    >
      <el-radio-button :value="ronTypeLabel.type_id">
        {{ ronTypeLabel.label }}
      </el-radio-button>
    </el-tooltip>
  </el-radio-group>
  <el-select
    v-else
    v-model="value"
    :disabled="disabled"
    @update:modelValue="update"
  >
    <el-option
      v-for="ronTypeLabel in RonTypeLabels"
      :key="ronTypeLabel.type_id"
      :label="ronTypeLabel.label"
      :value="ronTypeLabel.type_id"
    >
      {{ ronTypeLabel.label }}
    </el-option>
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { RonTypeLabels } from '@/api/types'
import useResize from '@/hooks/useResize'

export default defineComponent({
  name: 'RonTypeSelector',
  props: {
    modelValue: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const update = function (newValue: any) {
      context.emit('update:modelValue', parseInt(newValue))
    }

    const { isDesktop } = useResize()

    return { update, isDesktop, RonTypeLabels, value }
  }
})
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
</style>
